import React from "react";
import { withStyles } from "@material-ui/core/styles";
import { Paper, Typography, WithStyles } from "@material-ui/core";
import { styles } from "./ManageOrdersFilter.styles";
import ToggleButton from "@material-ui/lab/ToggleButton";
import ToggleButtonGroup from "@material-ui/lab/ToggleButtonGroup";
import { useTranslation } from "react-i18next";

const orderTypes = ["INTERNAL", "B2B"];
const orderStates = ["Registered", "Confirmed", "Processing", "Completed", "Failed", "Rejected", "Archived"];

export interface IManageOrdersFilterProps extends WithStyles<typeof styles> {
    orderTypesChecked: string[];
    orderStatesChecked: string[];
    onOrderTypeCheckboxClick: (event: React.MouseEvent<HTMLElement>, newTypes: string[]) => void;
    onOrderStateCheckboxClick: (event: React.MouseEvent<HTMLElement>, newStates: string[]) => void;
}

const ManageOrdersFilterPure: React.FunctionComponent<IManageOrdersFilterProps> = ({
    classes,
    orderTypesChecked,
    orderStatesChecked,
    onOrderTypeCheckboxClick,
    onOrderStateCheckboxClick
}: IManageOrdersFilterProps) => {
    const { t } = useTranslation();

    return (
        <Paper variant="outlined" className={classes.paper}>
            <div className={classes.root}>
                <div className={classes.filterSection}>
                    <Typography variant="h6">{t("admin.manageOrdersView.orderType")}</Typography>
                    <div className={classes.sectionInput}>
                        <ToggleButtonGroup
                            value={orderTypesChecked}
                            onChange={onOrderTypeCheckboxClick}
                            aria-label="text formatting"
                            className={classes.buttonGroup}
                        >
                            {orderTypes.map(orderType => (
                                <ToggleButton key={orderType} value={orderType} aria-label="bold" className={classes.toggleButton}>
                                    {orderType}
                                </ToggleButton>
                            ))}
                        </ToggleButtonGroup>
                    </div>
                </div>
                <div className={classes.filterSectionOrderState}>
                    <Typography variant="h6">{t("admin.manageOrdersView.orderState")}</Typography>
                    <div className={classes.sectionInput}>
                        <ToggleButtonGroup
                            value={orderStatesChecked}
                            onChange={onOrderStateCheckboxClick}
                            aria-label="text formatting"
                            className={classes.buttonGroup}
                        >
                            {orderStates.map(orderState => (
                                <ToggleButton key={orderState} value={orderState} aria-label="bold" className={classes.toggleButton}>
                                    {orderState}
                                </ToggleButton>
                            ))}
                        </ToggleButtonGroup>
                    </div>
                </div>
            </div>
        </Paper>
    );
};

export const ManageOrdersFilter = withStyles(styles)(ManageOrdersFilterPure);
